import { CommonModule } from '@angular/common';
import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { MatList, MatListItem } from '@angular/material/list';
import { AppHeaderComponent } from '../appHeader/appHeader.component';
import { LayoutComponent } from '../layout/layout.component';
import { BxNotification } from '@/app/interfaces/notification.interface';
import { NotificationService } from '@/app/services/notification/notification.service';
import { Router } from '@angular/router';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-notification-item',
  standalone: true,
  imports: [
    CommonModule,
    AppHeaderComponent,
    LayoutComponent,
    MatList,
    MatListItem,
    MatCardModule,
  ],
  templateUrl: './notification-item.component.html',
  styleUrl: './notification-item.component.css',
})
export class NotificationItemComponent implements OnInit {
  allNotifications: BxNotification[] = [];
  selectedNotification: BxNotification | null = null;
  @Output() notificationSelected: EventEmitter<BxNotification> =
    new EventEmitter<BxNotification>();
  constructor(
    private notificationService: NotificationService,
    private router: Router,
    private sanitizer: DomSanitizer
  ) {}

  ngOnInit() {
    this.notificationService.getAllNotifications().subscribe({
      next: (v: any) => {
        if (v && v.data.length > 0) {
          this.allNotifications = v.data;
        }
      },
    });
  }

  markAsRead(notification: BxNotification) {
    // TODO: send back request to make notification read
    notification.is_read = true;
  }

  selectNotification(notification: BxNotification) {
    this.selectedNotification = notification;
    this.notificationSelected.emit(notification); // Emit the selected notification
  }

  // getter
  get parsedSelectedNotificationData() {
    const data = JSON.parse(this.selectedNotification.data);
    return {
      ...data,
      notes: this.sanitizer.bypassSecurityTrustHtml(data.notes),
    };
  }
}
